import { Stack, Tooltip, Typography } from '@mui/material';
import AdsClickIcon from '@mui/icons-material/AdsClick';

const RequestAppointmentCounter = ({ count }) => {
  return (
    <Stack position="absolute" bottom={16} right={16} spacing={0}>
      <Tooltip title="Кол-во нажатий на 'Записаться'">
        <Stack direction="row" spacing={0.5}>
          <Typography variant="body2" component="div" color="templateText.secondary">
            {count ?? 0}
          </Typography>
          <AdsClickIcon fontSize="small" sx={{ color: '#b7b7b7' }} viewBox="0 0 24 24" />
        </Stack>
      </Tooltip>
    </Stack>
  );
};

export default RequestAppointmentCounter;